import { IController, IScope } from "angular";
import {  } from "@idha/idha-types";
import * as Raven from 'raven-js'
import { utilsModule } from "../../utils-module";
import { State, IGeoDatabase } from "@idha/idha-utils";

/**
 * @ngdoc component
 * @name app.component:stateSelector
 * @author William
 * @email william@idha.com.br
 * @description 
 * 
 * <b>IDHA TECNOLOGIA</b>
 * 
 * Nome do Componente: 'stateSelector'
 * 
 * Criação: 2019-01-02 15:55:00
 * 
 * Código do componente: CMP0002
 * 
 * Autor:  William 
 * 
 * Componente para listagem e seleção de estados
 * 
 * @see http://wiki.idha.com.br/index.php/CMP0002_-_Seletor_de_Estado
 * 
 * @param {string} ngModel sigla do estado/região selecionado
 * @param {string} selectionType tipo de seleção. 'UNIQUE' ou 'MULTIPLE'. O valor padrão é 'UNIQUE'.
 * @param {boolean} ngRequired indica se o campo é obrigatório ou não
 * @param {boolean} ngDisabled indica se o campo é desabilitado ou não
 * @param {boolean} showError indica se as mensagens de erro devem ou não ser exibidas
 * @param {string} form nome do formulário em que o componente está inserido
 * @param {string} class classe css a ser aplicada ao componente
 * @param {string} inputName nome do input. Se omitido, o nome "inpState" é usado(opcional)
 * @param {Array.State} stateList Lista de estados a serem exibidos
 * @param {string} countryName Nome do país. É utilizado para filtrar a lista de estados através do serviço getoDB, caso não tenha sido informado o stateList
 * @param {Function} onChangeSelection Callback disparado quando o item selecionado é alterado
 */
utilsModule.component('stateSelector', {
    template: require('./state-selector.component.html'),
    controller: ['geoDBService','$scope',stateSelectorController],
    bindings: {
        stateList:'=?',
        countryName:'=?',
        selectionType:'=?',
        ngModel:'=',
        ngRequired:'<?',
        ngDisabled:'=?',
        showError:'<?',
        form:'=?',
        class:'@?',
        inputName:'@?',
        onChangeSelection:'='
    }
})

/**
 * @interface
 * @ngdoc controller 
 * @name app.controller:StateSelectorController 
 * @description
 * 
 * Interface do controlador do componente stateSelector
 */
export interface StateSelectorController extends IController {

    /**
     * @ngdoc property
     * @name StateSelectorController#stateList
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * lista de estados a serem exibidos para seleção
     */
    stateList: State[]

    /**
     * @ngdoc property
     * @name StateSelectorController#countryName
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * Nome do país. É utilizado para filtrar a lista de estados através do serviço getoDB, caso não tenha sido informado o stateList
     */
    countryName:string
    
    /**
     * @ngdoc property
     * @name StateSelectorController#ngModel
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * sigla do estado selecionado
     */
    ngModel:string
    
    /**
     * @ngdoc property
     * @name StateSelectorController#ngRequired
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * indica se o campo é obrigatório ou não
     */
    ngRequired:boolean
    
    /**
     * @ngdoc property
     * @name StateSelectorController#ngDisabled
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * indica se o campo é desabilitado ou não
     */
    ngDisabled:boolean
    
    /**
     * @ngdoc property
     * @name StateSelectorController#showError
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * indica se as mensagens de erro devem ou não ser exibidas
     */
    showError:boolean
    
    /**
     * @ngdoc property
     * @name StateSelectorController#form
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * nome do formulário em que o componente está inserido
     */
    form:boolean
    
    /**
     * @ngdoc property
     * @name StateSelectorController#class
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * classe css a ser aplicada ao componente
     */
    class:string

    /**
     * @ngdoc property
     * @name CountrySelectorController#inputName
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * nome do input. Se omitido, o nome "inpState" é usado. 
     * É um parametro opcional
     */
    inputName:string
    
    /**
     * @ngdoc property
     * @name StateSelectorController#onChangeSelection
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * Callback disparado quando o item selecionado é alterado
     */
    onChangeSelection:()=>void

    /**
     * @ngdoc property
     * @name StateSelectorController#findStates
     * @propertyOf app.controller:StateSelectorController
     * @description
     * 
     * Atualiza a lista de estados, com base no país selecionado,
     * acessando o serviço geoDB.
     */
    findStates:()=>Promise<void>
}


/**
 * @name app.controller:stateSelectorController 
 * @implements StateSelectorController 
 * @description
 * 
 * Controlador do componente stateSelector
 */
function stateSelectorController(geoDBService:IGeoDatabase,$scope:IScope) {
    var ctrl: StateSelectorController = this;


    ctrl.$onInit = async function(){
        if(!ctrl.inputName) ctrl.inputName = 'inpState';

        if(!ctrl.stateList){            
            ctrl.findStates();

            $scope.$watch(()=>ctrl.countryName,()=>{
                ctrl.stateList = undefined;
                ctrl.findStates();
            })
        }
    }

    ctrl.findStates = async function():Promise<void>{
        if(!ctrl.countryName){
            ctrl.stateList = [];
            return;
        }
        ctrl.stateList = await geoDBService.listStates(ctrl.countryName);
        ctrl.stateList.sort((state1:State,state2:State)=>{
            return state1.name.localeCompare(state2.name);
        });
    }

    ctrl.filterStates = async function(searchText:string):Promise<string[]>{    
        await ctrl.stateList;
        return ctrl.stateList.filter((state:State)=>{
            return state.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1
        }).map((state:State)=>{
            return state.name
        })
    }
}